import { map } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/angular';
import * as moment from 'moment';
import 'moment/locale/fr';

import { Principal } from '../../../shared';
import { TrainersLabelPipe } from '../../_shared/trainers-label.pipe';
import { FormatDatePipe } from '../../_shared/format-date.pipe';
import { LabelSkillComponent } from '../../_shared/label/label.component';

import {
    Session,
    SessionService,
    Trainer,
    TrainerService,
} from '../../../_services';

@Component({
    selector: 'jhi-session-details',
    templateUrl: 'detail.component.html',
    styleUrls: [
        'detail.component.scss',
        '../../_shared/label/label.component.scss',
    ],
    providers: [
        TrainersLabelPipe,
        FormatDatePipe,
        LabelSkillComponent,
        TranslatePipe,
    ],
})
export class SessionDetailComponent implements OnInit {
    // static _lastTab: string = 'description';
    static _lastTab: string = 'description';

    account: any;
    error: string;
    success: string;
    session: Session;
    trainers: Trainer[];
    registrations: any[] = [];
    sessionId: number;
    priceUpdatedTimeout: any;
    selectedTrainers: any;
    trainersResponses: any[];

    constructor(
        private sessionService: SessionService,
        private trainerService: TrainerService,
        private trans: Transition,
        private principal: Principal
    ) {}

    public get getLastTab(): string {
        return SessionDetailComponent._lastTab;
    }

    public set setLastTab(lastTab: string) {
        SessionDetailComponent._lastTab = lastTab;
    }

    ngOnInit() {
        this.findSession();

        this.principal.identity().then((account) => {
            this.account = account;
        });

        this.trainerService.findAll().subscribe((trainers) => {
            this.selectedTrainers = {};
            this.trainers = trainers
                .filter((trainer) => {
                    return trainer.email && trainer.email.length > 0;
                })
                .map((trainer) => {
                    this.selectedTrainers[trainer.id] = {
                        trainer: trainer,
                        selected: false,
                    };
                    let trainerSkills = trainer.trainerSkills.map((skill) => {
                        skill.highLight = true;
                        return skill;
                    });
                    return new Trainer(
                        trainer.id,
                        trainer.firstName,
                        trainer.lastName,
                        '',
                        trainer.companyName,
                        trainer.email,
                        trainer.active,
                        trainerSkills,
                        trainer.bio
                    );
                });

            this.sessionService
                .getTrainersResponses(this.sessionId)
                .subscribe((responses) => {
                    this.trainersResponses = responses;
                });
        });
    }

    priceUpdated(event) {
        if (event.totalPrice === this.session.price) {
            return;
        }
        if (this.priceUpdatedTimeout) {
            clearTimeout(this.priceUpdatedTimeout);
        }
        // this.priceUpdatedTimeout = setTimeout(() => {
        //     this.findSession();
        //     this.priceUpdatedTimeout = null;
        // }, 1000);
    }

    findSession(): void {
        this.sessionId = this.trans.params()['id'];
        this.sessionService.findOne(this.sessionId).subscribe((session) => {
            let sessionTrainer = session.trainer
                ? session.trainer.firstName + ' ' + session.trainer.lastName
                : 'À définir';
            let sessionType =
                session.type === 'ONDEMAND'
                    ? 'ondemand'
                    : session.type === 'ONSITE'
                    ? 'intra'
                    : session.type === 'PUBLIC'
                    ? 'inter'
                    : 'autre';
            let sessionReference = 'F' + session.id;
            if (session.trainer && session.trainer.companyName) {
                sessionReference = session.trainer.companyName
                    .toUpperCase()
                    .includes('ZENIKA')
                    ? sessionReference + '-ZNK'
                    : sessionReference + '-ST';
            }
            let sessionLocation, sessionRoom, sessionLocal, sessionRoomSize;
            if (sessionType === 'intra') {
                const actualLocation = session.location || session.company;
                sessionLocation = actualLocation
                    ? actualLocation.city
                    : session.locationType === 'REMOTE'
                    ? 'À distance'
                    : 'À définir';
                sessionLocal = actualLocation
                    ? actualLocation.name
                    : 'À définir';
                sessionRoom =
                    session.location && session.room
                        ? session.room.name
                        : 'À définir';
                sessionRoomSize =
                    session.location && session.room
                        ? session.room.capacity
                        : Number.NaN;
            } else {
                sessionLocation = session.location
                    ? session.location.city
                    : session.locationType === 'REMOTE'
                    ? 'À distance'
                    : 'À définir';
                sessionLocal = session.location
                    ? session.location.name
                    : 'À définir';
                sessionRoom = session.room ? session.room.name : 'À définir';
                sessionRoomSize = session.room
                    ? session.room.capacity
                    : Number.NaN;
            }

            let sessionTrainerId;
            if (session.trainer) {
                sessionTrainerId = session.trainer.id;
            }

            session.hours.sort((hour1, hour2) => {
                return `${hour1.date} ${hour1.startTime}`.localeCompare(
                    `${hour2.date} ${hour2.startTime}`
                );
            });

            this.session = new Session(
                session.id,
                session.training.title,
                moment(session.startDate).toDate(),
                ' ',
                session.days,
                sessionTrainer,
                sessionTrainerId,
                sessionType,
                session.price,
                session.priceCurrency,
                sessionReference,
                session.language,
                session.timezone,
                sessionLocation,
                session.locationType,
                sessionLocal,
                sessionRoom,
                sessionRoomSize,
                session.registrations,
                session.training,
                session.billing,
                session.deleted,
                session.trainingSessionExtended
                    ? session.trainingSessionExtended.subject
                    : '',
                session.trainingSessionExtended
                    ? session.trainingSessionExtended.linkedTraining
                    : null,
                session.company,
                session.trainingSessionExtended,
                session.additionalTrainers,
                session.zevalAccessId,
                0,
                0,
                session.hours,
                session.synchronizeSignature,
                session.timesheetSaved,
                session.fees
            );
        });
    }

    getEndDate(): string {
        return moment(this.session.startDate)
            .add(this.session.days, 'days')
            .format('L');
    }

    isCurrentTab(tabName): boolean {
        return tabName === SessionDetailComponent._lastTab;
    }

    updateActiveTab(tabName): void {
        SessionDetailComponent._lastTab = tabName;
    }

    sendMail() {
        return (sessionId, trainerIds) => {
            return this.sessionService
                .proposeTrainingToTrainers(sessionId, trainerIds)
                .pipe(
                    map((_) => {
                        this.sessionService
                            .getTrainersResponses(this.session.id)
                            .subscribe((responses) => {
                                this.trainersResponses.length = 0;
                                this.trainersResponses.push(...responses);
                                return _;
                            });
                    })
                );
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/detail.component.ts